module.exports = {
      id: "back-usage",
      viewBox: "0 0 40 40",
      url: "img/" + "sprite.svg#back-usage",
      toString: function () {
        return this.url;
      }
    }